"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlaybackDiscordActivity = exports.EMPTY_DISCORD_TIMESTAMPS = exports.useDiscord = exports.DiscordProvider = void 0;
var Discord_1 = require("./Discord");
Object.defineProperty(exports, "DiscordProvider", { enumerable: true, get: function () { return Discord_1.DiscordProvider; } });
Object.defineProperty(exports, "useDiscord", { enumerable: true, get: function () { return Discord_1.useDiscord; } });
var activity_1 = require("./activity");
Object.defineProperty(exports, "EMPTY_DISCORD_TIMESTAMPS", { enumerable: true, get: function () { return activity_1.EMPTY_DISCORD_TIMESTAMPS; } });
Object.defineProperty(exports, "getPlaybackDiscordActivity", { enumerable: true, get: function () { return activity_1.getPlaybackDiscordActivity; } });
